module.exports = "//cdn.mxpnl.com/static/asset-cache/abf58fa89649137433a0aeedbb35065a/iron/common/widgets/query-report-header/images/alerts-upsell-images.svg";